import React from "react";
import PropTypes from "prop-types";
import { Link, useNavigate } from "react-router-dom";
import { INVOICE } from "../../../route/paths";
import { showToast } from "../../../utils/utils";
import {
  MODAL,
  REDIRECT,
  showToastType,
  TRACK_CUSTOM
} from "../../../utils/constants/appConstants";
import { metaPixel } from "../../../locales/en";

const AccountingSoftwareButton = ({
  type,
  icon,
  alt,
  name,
  authorizeFn,
  redirectKey,
  onClickModal
}) => {
  const navigate = useNavigate();

  const getValueFromPath = (obj, path) =>
    path?.split(".").reduce((acc, key) => acc?.[key], obj);

  const handleRedirect = async () => {
    try {
      const response = await authorizeFn();
      if (window.fbq) {
        window.fbq(TRACK_CUSTOM, metaPixel.connectAccountingSoftware);
      }
      const redirectUrl = getValueFromPath(response, redirectKey);
      redirectUrl ? (window.location.href = redirectUrl) : navigate(INVOICE);
    } catch (error) {
      showToast(error?.response?.data?.message, showToastType.error);
    }
  };

  const handleClick = () => {
    if (type === MODAL) return onClickModal();
    handleRedirect();
  };

  return (
    <li>
      <Link to="#" onClick={handleClick}>
        <img src={icon} alt={alt} />
        <span>{name}</span>
      </Link>
    </li>
  );
};

AccountingSoftwareButton.propTypes = {
  type: PropTypes.oneOf([MODAL, REDIRECT]).isRequired,
  icon: PropTypes.string.isRequired,
  alt: PropTypes.string,
  name: PropTypes.string,
  authorizeFn: PropTypes.func,
  redirectKey: PropTypes.string,
  onClickModal: PropTypes.func
};

export default AccountingSoftwareButton;
